import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  FormGroup,
  List,
  Tooltip,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import ColumnGroupIcon from "assets/images/icons/column-group.svg";
import { useBoundStore } from "useStore";
import LightTooltip from "views/Components/Shared/Components/LightTooltip";
import { COLUMNS_TO_FILTER, COLUMNS_TO_FILTER_ADS } from "./utils";

function Options({ closeTooltip }) {
  const selectedCampaign = useBoundStore((state) => state.selectedCampaign);
  const isAdsView = !!selectedCampaign;

  // Campañas
  const campaignColumns = useBoundStore((state) => state.campaignManagerColumns);
  const toggleCampaignColumns = useBoundStore(
    (state) => state.toggleCampaignManagerColumns,
  );
  const resetCampaignColumns = useBoundStore(
    (state) => state.resetCampaignManagerColumns,
  );

  // Ads
  const adsColumns = useBoundStore((state) => state.campaignManagerColumnsAds);
  const toggleAdsColumns = useBoundStore(
    (state) => state.toggleCampaignManagerColumnsAds,
  );
  const resetAdsColumns = useBoundStore(
    (state) => state.resetCampaignManagerColumnsAds,
  );

  const columnsConfig = isAdsView ? COLUMNS_TO_FILTER_ADS : COLUMNS_TO_FILTER;
  const columns = isAdsView ? adsColumns : campaignColumns;
  const toggleColumns = isAdsView ? toggleAdsColumns : toggleCampaignColumns;
  const resetColumns = isAdsView ? resetAdsColumns : resetCampaignColumns;

  const handleChange = (e) => {
    const { name, checked } = e.target;
    toggleColumns(name, checked);
  };

  const selectedColumns = columnsConfig.map((col) => columns[col.data]);
  const selectedCount = selectedColumns.filter(Boolean).length;
  const isAllColumnsSelected = selectedCount === selectedColumns.length;
  const isIndeterminate = !isAllColumnsSelected;

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    columnsConfig.forEach((column) => {
      toggleColumns(column.data, isChecked);
    });
  };

  return (
    <List
      sx={{ width: "340px", maxWidth: 340, bgcolor: "background.paper" }}
      component="nav"
      subheader={
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={isAllColumnsSelected}
                indeterminate={isIndeterminate}
                onChange={handleSelectAll}
              />
            }
            label={
              <Typography
                sx={{
                  pl: 2,
                  color: "rgba(0, 0, 0, 0.87)",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "700",
                  letterSpacing: "0.15px",
                  padding: "12px",
                }}
              >
                Filtrar columnas:
              </Typography>
            }
          />
        </Stack>
      }
    >
      <Divider />

      <List component="div" disablePadding>
        <Box sx={{ maxHeight: "200px", overflowY: "auto" }}>
          <FormGroup sx={{ pl: 2 }}>
            {columnsConfig.map((column) => (
              <Box key={column.data}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="secondary"
                      name={column.data}
                      checked={!!columns[column.data]}
                      onChange={handleChange}
                    />
                  }
                  label={column.label}
                />
                <Divider />
              </Box>
            ))}
          </FormGroup>
        </Box>
      </List>

      <Button color="secondary" onClick={closeTooltip} sx={{ mt: 1 }}>
        CERRAR
      </Button>
    </List>
  );
}

export default function FilterColumns() {
  const openTableCustomizationTooltip = useBoundStore(
    (state) => state.openPricingTableCustomizationTooltip,
  );
  const closeTableCustomizationTooltip = useBoundStore(
    (state) => state.closePricingTableCustomizationTooltip,
  );
  const tableCustomizationTooltip = useBoundStore(
    (state) => state.pricingTableCustomizationTooltip,
  );

  const handleTooltipClose = () => closeTableCustomizationTooltip();
  const handleToggleTooltip = () => openTableCustomizationTooltip();

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (tableCustomizationTooltip) handleTooltipClose();
      }}
    >
      <div>
        <LightTooltip
          PopperProps={{ disablePortal: true }}
          onClose={handleTooltipClose}
          open={tableCustomizationTooltip}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<Options closeTooltip={handleTooltipClose} />}
        >
          <div style={{ display: "inline-block" }}>
            <Tooltip title="Customizar Tabla" placement="bottom" arrow>
              <Box>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    padding: "8px",
                    width: "60px",
                    height: "50px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    border: "1px solid rgba(53, 72, 135, 1)",
                  }}
                  onClick={handleToggleTooltip}
                >
                  <img
                    src={ColumnGroupIcon}
                    alt="Icono de columnas"
                    style={{ fill: "#0000008F", width: "24px", height: "24px" }}
                  />
                </Stack>
              </Box>
            </Tooltip>
          </div>
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
